module.exports = __webpack_public_path__ + "img/fig05.20ee01e9.jpg";